

//export let API_URL = "http://localhost:8000";
export let API_URL = "https://apihoussem-adouni.com";



// export let FRONT_URL = "http://localhost:3000";
export let FRONT_URL = "https://51.38.32.78";
